enum FileUploadStatusCard {
  QUEUING = 'queuing',
  UPLOADING = 'uploading',
  SUCCESS = 'uploading success',
  FAILED = 'failed',
  DUPLICATED = 'duplicated',
}

export default FileUploadStatusCard;
